<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Remove member</p>
      </header>
      <section class="modal-card-body">
        <p>
          Area you sure you want to remove <span class="has-text-weight-bold">{{ member.email }}</span> as a member of <span class="has-text-weight-bold">{{ huntArea.name }}</span>?
        </p>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="removeError">
          {{ removeError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button
              class="button"
              @click="cancelRemoveMember"
              :disabled="isRemoving"
            >Cancel</button>
            <button
              class="button is-danger"
              @click="confirmRemoveMember"
              :class="{'is-loading': isRemoving}"
              :disabled="isRemoving"
            >Remove member</button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  REMOVE_MEMBER_WITH_ID
} from "./huntAreaStore";

export default {
  name: "HuntAreaRemoveMemberModal",

  props: {
    huntAreaStorePath: {
      type: String,
      required: true
    },

    huntArea: {
      type: Object,
      reqired: true
    },

    member: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isRemoving: false,
      removeError: null
    };
  },

  methods: {
    cancelRemoveMember() {
      this.$emit("cancelled");
    },

    async confirmRemoveMember() {
      const huntAreaId = this.huntArea.id;
      const userId = this.member.id;

      this.isRemoving = true;
      this.removeError = null;

      try {
        const removeMemberAction = `${this.huntAreaStorePath}/${REMOVE_MEMBER_WITH_ID}`;
        await this.$store.dispatch(removeMemberAction, { huntAreaId, userId });

        this.$emit("succeeded");
      } catch (error) {
        this.removeError = error || 'Something went wrong.';
      } finally {
        this.isRemoving = false;
      }
    }
  },

  computed: {
    showModal() {
      return this.member !== null;
    }
  }
}
</script>

<style>

</style>
